import * as XLSX from 'xlsx';

const HOST = process.env.REACT_APP_HOST;
const DEFAULT_IMG = 'storage/images/system/product-default.png';
const LOGO_IMG_PATH = HOST + 'storage/images/logos/';

const getImage = (url)=>{
    if (url && url.includes('storage')) {
        return HOST + url
    } else if(url) {
        return url;
    } else {
        return HOST + DEFAULT_IMG;
    }
}

const currencyFormater  = (value, rounded=false)=>{
    if (rounded) {
        value = Math.round(value);
    }
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value)
}

const downloadExcel = (idTable, name = 'Abi', callback) => {
  const sheetName = 'Abi';
  const timestamp = new Date().getTime();
  const fileName = `${sheetName} ${name} ${timestamp}.xlsx`;

  setTimeout(() => {
    const table = document.getElementById(idTable);
    const rows = table.querySelectorAll('tr');
    const data = [];

    rows.forEach(row => {
      const rowData = [];
      const cells = row.querySelectorAll('th, td');

      cells.forEach(cell => {
        let text = cell.textContent || '';

        // Elimina $ y espacios
        text = text.replace(/\$/g, '').trim();

        // Detecta formato con punto como separador de miles y coma como decimal (ej: 418.096,08)
        if (/^\d{1,3}(\.\d{3})*(,\d+)?$/.test(text)) {
          // Elimina puntos (miles) y cambia coma (decimal) por punto
          text = text.replace(/\./g, '').replace(',', '.');
        }

        // Verifica si es un número
        if (!isNaN(text) && text !== '') {
          rowData.push(parseFloat(text));
        } else {
          rowData.push(cell.textContent);
        }
      });

      data.push(rowData);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, fileName);

    if (typeof callback === 'function') {
      callback();
    }
  }, 50);
};


export { currencyFormater, getImage, downloadExcel, HOST,  DEFAULT_IMG, LOGO_IMG_PATH };